// import SpinnerIcon from "../../utils/icon/SpinnerIcon";
// import React, { useState } from 'react';
// import { toast } from 'react-toastify';
// import iconLike from "./../../ElementDetailOfACard/static/img/vector-1.svg";
// const FavoriteIcon = ({ cardUserCardId,cardId,  isFavorite, cardUserId, userId, toggleFavorite,size }) => {
//     const [isProcessing, setIsProcessing] = useState(false);
    

//      const IconLikeFull=()=>{
//     return(<svg width="24" height="20" viewBox="0 0 24 20" fill="#0071E7" xmlns="http://www.w3.org/2000/svg">
// <path d="M1.1665 7.39552C1.16653 6.28272 1.53223 5.1961 2.21531 4.27918C2.8984 3.36226 3.86673 2.65818 4.99241 2.25992C6.1181 1.86166 7.34818 1.78796 8.52018 2.04856C9.69219 2.30916 10.751 2.8918 11.5568 3.71952C11.6135 3.77553 11.6821 3.82019 11.7583 3.85072C11.8346 3.88125 11.9168 3.897 11.9998 3.897C12.0829 3.897 12.1651 3.88125 12.2413 3.85072C12.3176 3.82019 12.3862 3.77553 12.4429 3.71952C13.2461 2.88642 14.3052 2.29889 15.4791 2.03512C16.653 1.77135 17.8861 1.84386 19.0143 2.243C20.1424 2.64214 21.1122 3.34897 21.7944 4.26942C22.4766 5.18987 22.8389 6.28028 22.8332 7.39552C22.8332 9.68552 21.2082 11.3955 19.5832 12.8955L13.6335 18.2085C13.4316 18.4225 13.1828 18.5944 12.9034 18.7128C12.624 18.8312 12.3205 18.8934 12.0132 18.8952C11.7058 18.897 11.4015 18.8384 11.1205 18.7232C10.8395 18.6081 10.5883 18.4391 10.3835 18.2275L4.4165 12.8955C2.7915 11.3955 1.1665 9.69552 1.1665 7.39552Z" stroke="#F5F5F5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>)

//   }
   
//     const handleFavoriteToggle = async (event) => {
//       //event.stopPropagation(); // Prevent triggering the card's main onClick
  
//       if (isProcessing) return; // Prevent multiple requests during processing
  
//       setIsProcessing(true); // Set processing state to true
  
//       const MIN_PROCESSING_TIME = 1000; // Minimum time to show the spinner in milliseconds (1 second)
  
//       const startTime = Date.now(); // Record the start time
  
//       try {
//         await toggleFavorite(cardUserCardId,cardId); // Await the favorite toggle action
//    // Update state optimistically for immediate UI feedback
//       } catch (error) {
//         console.error('Error toggling favorite:', error);
//         toast.error('Failed to update favorite status.');
//       } finally {
//         const elapsedTime = Date.now() - startTime;
//         const remainingTime = MIN_PROCESSING_TIME - elapsedTime;
  
//         // Ensure the spinner shows for at least the minimum time
//         if (remainingTime > 0) {
//           setTimeout(() => {
//             setIsProcessing(false);
//           }, remainingTime);
//         } else {
//           setIsProcessing(false);
//         }
//       }
//     };
  

//     return (
//     //   parseInt(cardUserId) !== parseInt(userId) && (
//         <div
//           className="favorite-icon-wrapper"
//           onClick={handleFavoriteToggle}
//           style={{ width: '100%', height: '100%', cursor: 'pointer' }}
//           >
            
//           {isProcessing ? (
//             <SpinnerIcon />
//           ) : isFavorite ? (<img src={iconLike}></img>
//           ) : (
//             // <svg
//             //   xmlns="http://www.w3.org/2000/svg"
//             //   width={size}
//             //   height={size}
//             //   fill="grey"
//             //   viewBox="0 0 24 24"
//             // >
//             //   <path d="M16.5 3c-1.74 0-3.41 0.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55L12 19.1l-0.1-0.09C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04 0.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" />
//             // </svg>
//           <IconLikeFull/>
//           )}
//         </div>
//       )
//    // );
//   };
//   export default FavoriteIcon;



import SpinnerIcon from "../../utils/icon/SpinnerIcon";
import React, { useState } from "react";
import { toast } from "react-toastify";
import iconLike from "./../../ElementDetailOfACard/static/img/vector-1.svg";

const FavoriteIcon = ({
  cardUserCardId,
  cardId,
  isFavorite,
  cardUserId,
  userId,
  toggleFavorite,
  size, // optional: width, height will be 5/6 of this
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  // ---- sizing rules ----
  const width = typeof size === "number" ? size : 24;
  const height =
    typeof size === "number" ? Math.round((size * 5) / 6) : 20;

  const IconLikeFull = ({ w = width, h = height }) => (
    <svg
      width={w}
      height={h}
      viewBox="0 0 24 20"
      fill="#0071E7"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M1.1665 7.39552C1.16653 6.28272 1.53223 5.1961 2.21531 4.27918C2.8984 3.36226 3.86673 2.65818 4.99241 2.25992C6.1181 1.86166 7.34818 1.78796 8.52018 2.04856C9.69219 2.30916 10.751 2.8918 11.5568 3.71952C11.6135 3.77553 11.6821 3.82019 11.7583 3.85072C11.8346 3.88125 11.9168 3.897 11.9998 3.897C12.0829 3.897 12.1651 3.88125 12.2413 3.85072C12.3176 3.82019 12.3862 3.77553 12.4429 3.71952C13.2461 2.88642 14.3052 2.29889 15.4791 2.03512C16.653 1.77135 17.8861 1.84386 19.0143 2.243C20.1424 2.64214 21.1122 3.34897 21.7944 4.26942C22.4766 5.18987 22.8389 6.28028 22.8332 7.39552C22.8332 9.68552 21.2082 11.3955 19.5832 12.8955L13.6335 18.2085C13.4316 18.4225 13.1828 18.5944 12.9034 18.7128C12.624 18.8312 12.3205 18.8934 12.0132 18.8952C11.7058 18.897 11.4015 18.8384 11.1205 18.7232C10.8395 18.6081 10.5883 18.4391 10.3835 18.2275L4.4165 12.8955C2.7915 11.3955 1.1665 9.69552 1.1665 7.39552Z"
        stroke="#F5F5F5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const handleFavoriteToggle = async () => {
    if (isProcessing) return;
    setIsProcessing(true);

    const MIN_PROCESSING_TIME = 1000;
    const start = Date.now();

    try {
      await toggleFavorite(cardUserCardId, cardId);
    } catch (err) {
      console.error("Error toggling favorite:", err);
      toast.error("Failed to update favorite status.");
    } finally {
      const elapsed = Date.now() - start;
      const remaining = MIN_PROCESSING_TIME - elapsed;
      if (remaining > 0) setTimeout(() => setIsProcessing(false), remaining);
      else setIsProcessing(false);
    }
  };

  return (
    <div
      className="favorite-icon-wrapper"
      onClick={(e) => {
  e.preventDefault();
  e.stopPropagation();
  handleFavoriteToggle(); // or handleFavoriteToggle(id)
}}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
      role="button"
    >
      {isProcessing ? (
        <SpinnerIcon width={width} height={height} />
      ) : !isFavorite ? (
        <img
          src={iconLike}
          width={width}
          height={height}
          alt=""
          aria-hidden="true"
        />
      ) : (
        <IconLikeFull w={width} h={height} />
      )}
    </div>
  );
};

export default FavoriteIcon;
